import { useQuery } from "react-query";
import { LookUpApiService } from "../../ApiServices";

type lookupDataType = {
    id: number;
    name?: string;
    title?: string;
};
type activityTopicsType = { searchText: string };
type childrenActivityType = { searchText: string; type: number };

const activityModuleName = "Activity_Topics";

export const commonKeys = {
    activityTopics: (payload: activityTopicsType) => [activityModuleName, "list", payload],
    childrenActivity: (payload: childrenActivityType) => [activityModuleName, "list", payload]
};

export const useActivityTopicsLookup = (payload: activityTopicsType) => {
    return useQuery(commonKeys.activityTopics(payload), () => LookUpApiService.getActivityTopics(payload), {
        select: ({ ok, data, response }: { ok: boolean; response: any; data: any }) => {
            if (ok) {
                const mutatedData = data.list.map((item: lookupDataType) => {
                    return {
                        value: item.id,
                        label: item.name
                    };
                });
                return mutatedData;
            }
            throw response?.message;
        }
    });
};

export const useChildrenActivitiesLookup = (payload: childrenActivityType) => {
    return useQuery(commonKeys.childrenActivity(payload), () => LookUpApiService.getChildrenActivities(payload), {
        select: ({ ok, data, response }: { ok: boolean; response: any; data: any }) => {
            if (ok) {
                const mutatedData = data.list.map((item: lookupDataType) => {
                    return {
                        value: item.id,
                        label: item.title,
                        type: payload.type
                    };
                });
                return mutatedData;
            }
            throw response?.message;
        },
        enabled: !(payload.type === null)
    });
};
